import { Paper, styled } from '@mui/material';

export const StyledProgramInfoBlockWrap = styled(Paper)({
	position: 'relative',
	padding: '8px 16px',
	gap: '12px',
	borderRadius: '10px',
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
});

export const StyledProgramInfoBlockHeader = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
});

export const StyledProgramInfoBlockCounter = styled('div')(({ theme }) => ({
	background: theme.palette.primary.main,
	color: theme.palette.primary.contrastText,
	width: '21px',
	height: '16px',
	borderRadius: '18px',

	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}));
